import React, { Component } from 'react';
import { Button } from 'react-bootstrap';
import Select from 'react-select';

interface VasLeftProps {
    searchParams: Object
    vehicleMakes: Array<string>
    vehicleModels: Array<string>
    vehicleDrivers: Array<string>
    vehicleStatusTypes: Array<string>
    vehicleStates: Array<string>
    profitCenters: Array<string>
    lastDriver: string
    selectedMake: string
    selectedModel: string
    selectedStatus: string
    selectedState: string
    selectedArea: string
    MaintenanceNum: string
    setModel: Function
    setMake: Function
    setVehicleStatus: Function
    setMaintenanceNumber: Function
    setDriver: Function
    setTheState: Function
    setArea: Function
    appendParams: Function
}

type VasLeftTypes = {

    MaintenanceNum: string
}

class VasLeft extends Component<VasLeftProps, VasLeftTypes> {

    constructor(props: any) {
        super(props)
        this.state = {
            MaintenanceNum: ""
        }
    }

    componentDidMount() {
        let param: any = this.props.searchParams
        this.setState({ MaintenanceNum: param.MaintenanceNum })
    }

    handleChange = (event: { target: { name: any, value: any } }) => {
        this.setState({ MaintenanceNum: event.target.value })
        this.props.setMaintenanceNumber([{ [event.target.name]: event.target.value }])
    }

    clearForm = (propertyName: any) => {
        this.setState({ [propertyName]: "" } as Pick<VasLeftTypes, keyof VasLeftTypes>)
        this.props.appendParams([{ [propertyName]: "" }])
    }

    render() {
        return (
            <div className="VAS-LP">
                <div className="VAS-LP-Status-Wrapper">
                    {this.props.selectedStatus !== "--Select Status--" && <div className="VAS-trashcan">
                        <Button id="vas-clear-param-btn" variant="danger" tabIndex={-1} onClick={() => this.props.setVehicleStatus([{ VehicleStatusTypeId: "", text: "" }], "--Select Status--")}>
                            <span id="vas-clear-x-btn" className="material-icons">
                                close
                            </span>
                        </Button>
                    </div>}
                    <Select
                        id="dropdown-basic-button-vas-model-btn"
                        value={{ value: 0, label: this.props.selectedStatus }}
                        options={this.props.vehicleStatusTypes.map((s: any) => ({ value: s.id, label: s.text }))}
                        onChange={(val: any) => {
                            this.props.setVehicleStatus([{ VehicleStatusTypeId: val.value }], val.label);
                        }}
                    />
                </div>
                <div className="VAS-LP-Make-Model">
                    <div className="VAS-LP-Make-Wrapper">
                        {this.props.selectedMake !== "--Select Make--" && <div className="VAS-trashcan">
                            <Button id="vas-clear-param-btn" variant="danger" tabIndex={-1} onClick={() => this.props.setMake([{ VehicleMakeId: "" }], "--Select Make--")}>
                                <span id="vas-clear-x-btn" className="material-icons">
                                    close
                                </span>
                            </Button>
                        </div>}
                        <Select
                            id="dropdown-basic-button-vas-model-btn"
                            value={{ value: 0, label: this.props.selectedMake }}
                            options={this.props.vehicleMakes.map((s: any) => ({ value: s.id, label: s.text }))}
                            onChange={(val: any) => {
                                this.props.setMake([{ VehicleMakeId: val.value }], val.label);
                            }}
                        />
                    </div>
                    <div className="VAS-LP-Model-Wrapper">
                        {this.props.selectedModel !== "--Select Model--" && <div className="VAS-trashcan">
                            <Button id="vas-clear-param-btn" variant="danger" tabIndex={-1} onClick={() => this.props.setModel([{ VehicleModelId: "" }], "--Select Model--")}>
                                <span id="vas-clear-x-btn" className="material-icons">
                                    close
                                </span>
                            </Button>
                        </div>}
                        {this.props.vehicleModels.length > 0 && <Select
                            id="dropdown-basic-button-vas-model-btn"
                            value={{ value: 0, label: this.props.selectedModel }}
                            options={this.props.vehicleModels.map((s: any) => ({ value: s.id, label: s.text }))}
                            onChange={(val: any) => {
                                this.props.setModel([{ VehicleModelId: val.value }], val.label);
                            }}
                        />}
                    </div>
                    <div className="VAS-LP-Last-Driver-Wrapper">
                        {this.props.lastDriver !== "--Last Driver--" && <div className="VAS-trashcan">
                            <Button id="vas-clear-param-btn" variant="danger" tabIndex={-1} onClick={() => this.props.setDriver([{ DriverId: "" }], "--Last Driver--")}>
                                <span id="vas-clear-x-btn" className="material-icons">
                                    close
                                </span>
                            </Button>
                        </div>}
                        <Select
                            id="dropdown-basic-button-vas-model-btn"
                            value={{ value: 0, label: this.props.lastDriver }}
                            options={this.props.vehicleDrivers.map((s: any) => ({ value: s.id, label: s.text }))}
                            onChange={(val: any) => {
                                this.props.setDriver([{ DriverId: val.value }], val.label);
                            }}
                        />
                    </div>
                    <div className="VAS-LP-State-Wrapper">
                        {this.props.selectedState !== "--Select State--" && <div className="VAS-trashcan">
                            <Button id="vas-clear-param-btn" variant="danger" tabIndex={-1} onClick={() => this.props.setTheState([{ StateId: "" }], "--Select State--")}>
                                <span id="vas-clear-x-btn" className="material-icons">
                                    close
                                </span>
                            </Button>
                        </div>}
                        <Select
                            id="dropdown-basic-button-vas-model-btn"
                            value={{ value: 0, label: this.props.selectedState }}
                            options={this.props.vehicleStates.map((s: any) => ({ value: s.id, label: s.text }))}
                            onChange={(val: any) => {
                                this.props.setTheState([{ StateId: val.value }], val.label);
                            }}
                        />
                    </div>
                    <div className="VAS-LP-Area-Wrapper">
                        {this.props.selectedArea !== "--Select Location--" && <div className="VAS-trashcan">
                            <Button id="vas-clear-param-btn" variant="danger" tabIndex={-1} onClick={() => this.props.setArea([{ ProfitCenterId: "" }], "--Select Location--")}>
                                <span id="vas-clear-x-btn" className="material-icons">
                                    close
                                </span>
                            </Button>
                        </div>}
                        <Select
                            id="dropdown-basic-button-vas-model-btn"
                            value={{ value: 0, label: this.props.selectedArea }}
                            options={this.props.profitCenters.map((s: any) => ({ value: s.id, label: s.text }))}
                            onChange={(val: any) => {
                                this.props.setArea([{ ProfitCenterId: val.value }], val.label);
                            }}
                        />
                    </div>
                </div>
            </div>
        )
    }
}

export default VasLeft